<template>
  <b-modal v-model="showModal" size="xl" title-class="font-18" hide-footer>
    <template #modal-title>
      <div class="row">
        <div class="col-md-12 d-flex">
          <span 
            class="material-icons m-1 rounded-circle badge"
            :style="'background-color: '+ dadosTela.ds_cor_web"
            style="color: #fff; font-size: 18px;"
          >
            <i :class="'mdi ' + dadosTela.ds_icone_web"></i>
          </span>

          <span class="p-1">{{dadosTela.ds_norma}}</span>

          <span
            class="badge badge-pill font-size-18"
            style="height: max-content;"
            :class="{
                'badge-soft-primary': dadosModal.ds_st_lancamento === 'Liberado',
                'badge-soft-danger': dadosModal.ds_st_lancamento === 'Rejeitado',
                'badge-soft-danger': dadosModal.ds_st_lancamento === 'Pré-rejeitado',
                'badge-soft-warning': dadosModal.ds_st_lancamento === 'Pendente',
                'badge-soft-info': dadosModal.ds_st_lancamento === 'Pré-aprovado',
                'badge-soft-success': dadosModal.ds_st_lancamento === 'Aprovado'
              }"
          >
            {{dadosModal.ds_st_lancamento}}
          </span>
        </div>
      </div>
    </template>
    <div class="row">
      <div class="col-md-8">
        <div class="row mb-2 flex-responsive">
          <b-form-group
            id="carteira"
            label-for="carteira"
            label="Carteira (Origem do recurso)"
            class="col-md-6 mb-2"
          >
            <b-form-input 
              id="carteira"
              v-model="this.dadosTela.ds_carteira"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="data"
            label-for="data"
            label="Dt. Lançamento"
            class="col-md-2 mb-2"
          >
            <b-form-input 
              id="data"
              :value="$tools.converteData(dadosTela.dt_lancamento)"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="valorOriginal"
            label-for="valorOriginal"
            label="Valor Original"
            class="col-md-2 mb-2"
          >
            <b-form-input 
              id="valorOriginal"
              :value="$tools.converteReal(dadosTela.vl_original)"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="valor"
            label-for="valor"
            label="Vl. Lançamento"
            class="col-md-2 mb-2"
          >
            <b-form-input 
              id="Valor"
              class="text-uppercase"
              v-model="valorLancamento"
              :disabled="desativa"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="local"
            label-for="local"
            label="Local - Estabelecimento"
            class="col-md-6 mb-2"
          >
            <b-form-input 
              id="local"
              v-model="this.dadosTela.nm_localidade"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="cidade"
            label-for="cidade"
            label="Cidade Lançamento"
            class="col-md-6 mb-2"
          >
            <b-form-input 
              id="norma"
              v-model="this.dadosTela.cidade_uf_movimento"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="observacao"
            label-for="observacao"
            label="Observação"
            class="col-md-12 mb-2"
          >
            <b-form-input 
              id="observacao"
              v-model="this.dadosTela.ds_obs"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="tipoLimite"
            label-for="tipoLimite"
            label="Tipo de Limite"
            class="col-md-2 mb-2"
          >
            <b-form-input 
              id="tipoLimite"
              v-model="this.dadosTela.tp_limite"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="valor"
            label-for="valor"
            label="Valor Limite"
            class="col-md-2 mb-2"
          >
            <b-form-input 
              id="valor"
              :value="$tools.converteReal(dadosTela.vl_limite)"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="cidadeExcesso"
            label-for="cidadeExcesso"
            label="Bloq. Excesso?"
            class="col-md-2 mb-2"
          >
            <b-form-input 
              id="cidadeExcesso"
              v-model="this.dadosTela.ds_st_bloq_excesso"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="cidadeSede"
            label-for="cidadeSede"
            label="Bloq. Sede?"
            class="col-md-2 mb-2"
          >
            <b-form-input 
              id="cidadeSede"
              v-model="this.dadosTela.ds_st_bloq_cidade_sede"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            id="cidadeSedeNome"
            label-for="cidadeSedeNome"
            label="Cidade Sede"
            class="col-md-4 mb-2"
          >
            <b-form-input 
              id="cidadeSedeNome"
              v-model="this.dadosTela.ds_regiao_coop"
              class="text-uppercase"
              disabled="disabled"
            >
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Justificativa"
            label-for="Justificativa"
            class="mb-3"
          >
            <b-form-textarea
              for="Justificativa"
              v-model="justificativa"
              placeholder="Observações"
              :maxlength="200"
              class="col-md-12"
              :disabled="desativa"
            ></b-form-textarea>
            <div class="text-center">
              <p
                v-if="justificativa"
                class="badge position-absolute"
                :class="{ 'bg-success': justificativa.length !== 200,
                          'bg-danger': justificativa.length === 200 }"
              >
                {{ justificativa.length }} / 200
              </p>
            </div>
          </b-form-group>

          <div
            class="btn-group mb-3"
            role="group"
          >
            <b-button variant="danger" class="w-xs" @click="rejeitarRdv()" :disabled="desativa">
              <i class="mdi mdi-thumb-down"> Rejeitar</i>
            </b-button>
            <b-button variant="primary" class="w-xs" @click="aprovarRdv()" :disabled="desativa">
              <i class="mdi mdi-thumb-up"> Aprovar</i>
            </b-button>
          </div>

        </div>
        <div class="d-flex justify-content-center" v-if="loading">
          <b-spinner
            class="m-2"
            variant="primary"
            role="status"
          ></b-spinner>
        </div>  
        <b-card no-body class="mb-1 shadow-none" v-for="(item, index) in informacoes" :key="index">
          <b-card-header header-tag="header" role="tab">
            <h6 
                v-b-toggle="'info'+index"
                class="m-0 text-dark"
                href="javascript: void(0);"
              >
              {{ item.nome }}
            </h6>
          </b-card-header>
          <b-collapse :id="'info'+index" accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-card-text>{{ item.texto }}</b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div class="col-lg-4 col-md-12">
        <img 
          v-if="arquivo.tipoComprovante == 'img'" 
          :src="arquivo.comprovante" 
          @click="singleImage = true"  
          class="tamanhoComprovante pointer div-clickable"
        />
        <vue-easy-lightbox
          :visible="singleImage"
          :imgs="arquivo.comprovante"
          @hide="singleImage = false"
        ></vue-easy-lightbox>
        
        <iframe v-if="arquivo.tipoComprovante == 'pdf'" 
                :src="criarUrlBase64(arquivo.comprovante)"
                class="tamanhoComprovante ">
        </iframe>
        <img v-else 
             :src="arquivo.comprovante" 
             @click="singleImage = true"  
             class="tamanhoComprovante pointer div-clickable"
        />
        <div class="d-flex justify-content-center btn-toolbar">
          <b-button
            variant="info"
            size="md"
            class="m-1"
            @click="anterior()" :disabled="!somaChave ? true : false"
          >
            <i class="mdi mdi-arrow-left">Anterior</i>
          </b-button>
          <b-button
            variant="info"
            size="md"
            class="m-1"
            @click="proximo()" :disabled="passaRegistro"
          >
            Próximo <i class="mdi mdi-arrow-right"></i>
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import VueEasyLightbox from "vue-easy-lightbox";
import { required } from "vuelidate/lib/validators";

  export default {
    components: { VueEasyLightbox },
    props: {
      title: String, // para dar nome ao campo
      arrayDados: Array,
      desativa: Boolean,
    },
    data() {
      return {
        justificativa: "",
        img:[],
        dadosTela: [],
        chave:0,
        chaveAux: 0,
        singleImage: false,
        submit: false,
        informacoes: [],
        loading:true,
        arquivo:{
          tipoComprovante:"",
          comprovante:"",
        },
        dadosModal:{},
        showModal:false

      }
    },
    computed:{
      passaRegistro(){
        if(this.somaChave == this.arrayDados.length - 1){
          return true
        } else {
          return false
        }
      },
      somaChave(){
        return this.chave + this.chaveAux
      },
      valorLancamento(){
        return this.$tools.converteReal(this.dadosTela.vl_lancamento) 
      },
    },
    validations: {
      justificativa: { 
        required
      }
    },
    methods: {
      abrirModal(chave){
        this.chave = chave;
        this.showModal = true;
        this.atribuiValores();
      },
      buscarMovimentoRdv(){
        this.informacoes = [];
        var transacao = "";
        var carteira = "";
        var sequencia = 0;
        switch (this.dadosTela.ds_carteira) {
          case "Mastercard":
            transacao = this.dadosTela.id_mastercard_transacao;
            carteira = "Mastercard";
            break;
          case "Recurso próprio":
            transacao = this.dadosTela.sq_lcto_recurso_proprio;
            carteira = "RecursoProprio";
            break;
          case "Good Card":
            transacao = this.dadosTela.sq_lcto_utilizacao_frota;
            carteira = "GoodCard";
            break;
          case "Adiantamento":
            transacao = this.dadosTela.nr_credito_adiantamento;
            carteira = "Adiantamento";
            break;
          case "Ticket Log":
            transacao = this.dadosTela.nr_credito_adiantamento;
            carteira = "TicketLog";
            break;
        }
        this.$http.get("api/rdvTomador/buscarJustificativas/"+carteira+"/"+transacao+"/"+sequencia)
        .then((response) => {
          response.data.forEach((el) => {
            this.informacoes.push({
              nome:this.$tools.converteData(el.dt_usuinc) +" - "+
                   el.usuario.pessoa.nm_razao + " - " + 
                   this.$tools.statusDespesa(el.st_status),
              texto:el.ds_obs
            });
          })
          this.loading = false;
        }).catch((err) => {
          console.log(err);
          this.loading = false;
        });
      },
      criarUrlBase64(param){
        var blobAux = this.$tools.base64toBlob(param);
        return URL.createObjectURL(blobAux);
      },
      async atribuiValores(){    
        this.show = true;
        this.chaveAux = 0;
        this.dadosTela = this.arrayDados[this.somaChave]
        this.emitindoTituloModal()
        this.buscarMovimentoRdv();
        this.arquivo = await this.$tools.filtroCooperado.buscarComprovante(this.dadosTela.sq_upload);
      },
      async proximo(){
        this.arquivo = {};
        this.chaveAux++;
        this.dadosTela = this.arrayDados[this.somaChave];
        this.loading = true;
        this.emitindoTituloModal();
        this.buscarMovimentoRdv();
        this.arquivo = await this.$tools.filtroCooperado.buscarComprovante(this.dadosTela.sq_upload);
      }, 
      async anterior(){
        this.arquivo = {};
        this.chaveAux--;
        this.dadosTela = this.arrayDados[this.somaChave];
        this.loading = true;
        this.emitindoTituloModal();
        this.buscarMovimentoRdv();
        this.arquivo = await this.$tools.filtroCooperado.buscarComprovante(this.dadosTela.sq_upload);
      },
      emitindoTituloModal(){
        this.$emit("trocaTituloModal", 
                    this.dadosTela.ds_norma,
                    this.dadosTela.ds_st_lancamento, 
                    this.dadosTela.ds_icone_web,
                    this.dadosTela.ds_cor_web,
                    this.dadosTela.st_lancamento
                  )
      },
      aprovarRdv(){
        this.submit = true;
        this.$v.$touch();
        if(this.$v.$invalid) {
          return
        }
        this.$http.post("api/rdvTomador/aprovar", {
          "sq_usuario":this.$store.state.me.sq_usuario,
          "cd_rdv": this.dadosTela.cd_rdv,
          "cd_servico": this.dadosTela.cd_servico,
          "cd_norma": this.dadosTela.cd_norma,
          "dt_lancamento": this.dadosTela.dt_lancamento,
          "sq_lancamento": this.dadosTela.sq_lancamento,
          "cd_norma_new": this.dadosTela.cd_norma,
          "sq_regiao_new": this.dadosTela.sq_regiao,
          "vl_lacamento_new": this.dadosTela.vl_original,
          "justificativa": this.justificativa
        }).then((response)=>{
          this.dadosTela.ds_st_lancamento = response.data.ds_st_lancamento;
          this.emitindoTituloModal()
          this.$tools.alerta("Aprovado com sucesso", "success")
        }).catch((err)=>{
          console.log(err);
        })
      },
      rejeitarRdv(){
        this.submit = true;
        this.$v.$touch();
        if(this.$v.$invalid) {
          return
        }
        this.$http.post("api/rdvTomador/rejeitar", {
          "sq_usuario":this.$store.state.me.sq_usuario,
          "cd_rdv": this.dadosTela.cd_rdv,
          "cd_servico": this.dadosTela.cd_servico,
          "cd_norma": this.dadosTela.cd_norma,
          "dt_lancamento": this.dadosTela.dt_lancamento,
          "sq_lancamento": this.dadosTela.sq_lancamento,
          "justificativa": this.justificativa
        }).then((response)=>{
          this.dadosTela.ds_st_lancamento = response.data.ds_st_lancamento;
          this.emitindoTituloModal()
          this.$tools.alerta("Recussado com sucesso", "error")
        }).catch((err)=>{
          console.log(err);
        })
      },
    },
  }
</script>
<style>
  .tamanhoComprovante {
    width: 100%;
    height: 552px;
  }
  @media (min-width: 1200px){
    .modal-xl {
      max-width: 90%;
    }
    .modal-content {
      width: 100%;
    }
  }
</style>